<script>
	module.exports = {
		components: {
			'article-result-content': require('components/article-result-content.vue').default
		},
		props: {
			content: {
				default: []
			},
			onProductLinkClick: {
				default: function () {}
			},
			debug: {
				default: false
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	.featured-content {
		border-bottom: 1px solid $c-grey;
		padding-bottom: 2rem;
		margin-bottom: 2rem;

		.article-result-content {
			float: left;

			.title-container .pill {
				display: none;
			}

			.article-meta {
				.qset-totals,
				.text-type {
					display: none;
				}
			}
		}
	}
</style>
<template>
	<div class="featured-content row">
		<article-result-content
			v-for="article in content"
			:key="article.uuid"
			class="medium-6"
			:article="article"
			@click.native="onProductLinkClick({ pid: article.uuid, loc: 'FEATURED_CONTENT' })"
			:show-summary="false"
			:debug="debug">
		</article-result-content>
	</div>
</template>
